import { useState, useEffect, useRef, useCallback } from "react"; 
import { Link } from "react-router-dom";
import '../../style/App.css';
import DashBoard from "../DashBoard"
import UserMenu from "../UserMenu"

function Home() {
  const [serverFailure, setServerFailure] = useState("");
  const [userReload, setUserReload] = useState(1);
  function incrUserReload() { setUserReload(userReload + 1) }
  const [userRelogin, setUserRelogin] = useState(1);
  const [showLogin, setShowLogin] = useState(1);
  function incrShowLogin() { setShowLogin(showLogin + 1) }

  const [userID, setUserID] = useState("");
  const [userPassword, setUserPassword] = useState();
  const [userPublicForms, setUserPublicForms] = useState([]);
  const [userPrivateForms, setUserPrivateForms] = useState([]);
  const [userLogo, setUserLogo] = useState();
  const [userLastLogin, setUserLastLogin] = useState();
  const [userLevel, setUserLevel] = useState(0);
  const [userUsage, setUserUsage] = useState(0);
  const [userStripePk, setUserStripePk] = useState("");

  // If on page (re)load the user/password are in session, redo login
  //   This is the easy way to keep form data arrays in sync ;-)
  useEffect(() => {
//    console.log("Reload user information from session: " + userReload);
    setUserID(window.sessionStorage.getItem("userID"));
    setUserLogo(window.sessionStorage.getItem("userLogo"));
    setUserPassword(window.sessionStorage.getItem("userPassword"));
    setUserPublicForms(JSON.parse(window.sessionStorage.getItem("userPublicForms")));
    setUserPrivateForms(JSON.parse(window.sessionStorage.getItem("userPrivateForms")));
    setUserLastLogin(window.sessionStorage.getItem("userLastLogin"));
    setUserLevel(window.sessionStorage.getItem("userLevel"));
    setUserUsage(window.sessionStorage.getItem("userUsage"));
    setUserStripePk(window.sessionStorage.getItem("userStripePk"));
  }, [userReload]);

  const defaultCallback = (data) => {
    if (data.success === true)
    {
      // Reload/re-login after backend operation
      setUserReload(userReload + 1);
      setUserRelogin(userRelogin + 1);
      setServerFailure("");
    }
    else if (data.message.endsWith('expired'))
    {
      setServerFailure(data.message);
      window.sessionStorage.removeItem("userID");
      window.sessionStorage.removeItem("userPassword");
      window.sessionStorage.removeItem("userPublicForms");
      window.sessionStorage.removeItem("userPrivateForms");
      window.sessionStorage.removeItem("userLevel");
      window.sessionStorage.removeItem("userUsage");
      incrShowLogin();
      console.log("Expired, opening sign in");
    }
    else
    {
      // Otherwise read and save in state login failure message
      setServerFailure(data.message);
    }
  };

  // ---------------------------------------------------------------
  // Return the App page HTML
  // ---------------------------------------------------------------
  return (
    <div className="App">
      <header className="App-header">
        <img src="./header_background.png" alt="logo" width="100%" />
        <div style={{position: "relative", top: "-50px", height: "0px"}}>
            <b style={{fontSize: "32px"}}>Empower Your Passion</b>
        </div>
      </header>
      <div className="left_top_header">
        <img width="80px" alt="branding" src="./Immutable_WhiteOnTransparent_Logo.png"/>
      </div>
      <div align="center" className="center_top_header">
        <b style={{fontSize:"16px"}}>Dashboard</b>
        &nbsp;&nbsp;
        <Link className="textButton" title="Documentation" to="/Documentation">
                    Documentation
        </Link>
        &nbsp;&nbsp;
        <Link className="textButton" title="Plans and Pricing" to="/Pricing">
                    Plans
        </Link>
        <br />
        Form<i><b>Ally</b></i>
      </div>
      <font color="red">
        { serverFailure && serverFailure.length > 0 ? serverFailure : <br />}
      </font>
      <DashBoard data={{ userID, userPassword, userPublicForms,
                         userPrivateForms, userLastLogin,
                         userLevel, userStripePk, defaultCallback }} />
      <UserMenu homeData={{ setServerFailure, incrUserReload, userRelogin, showLogin }} />
      <br />
      <br />
      <br />
      <br />
      <div style={{fontSize:"10px"}} align="left">
        © 2024 <a href="https://www.immutablesoft.org/">ImmutableSoft Inc.</a>
        <br/>
        <sup>UIcons by <a href="https://www.flaticon.com/uicons" target="_blank" rel="noreferrer noopener">Flaticon</a></sup>
        <br />
      </div>
    </div>
  );
}

export default Home;
